<template>
  <div class="row boxes-row">
    <div :class="boxClass" v-for="box in boxes" :key="box.idTeamMember">
      <TeamMemberBox :box="box"></TeamMemberBox>
    </div>
  </div>
</template>

<script>
import TeamMemberBox from "@/components/persons/TeamMemberBox";
export default {
  components: {TeamMemberBox},
  props: ['boxClass', 'boxes'],
  name: "TeamMemberGrid"
}
</script>

<style scoped>

</style>